import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
  background-color: #e5f5f2;
  border-radius: 20px;

  .main-div {
    background-color: white;
    border-radius: 20px;
  }
`;

export const ContentSection = styled.div`
  @media screen and (min-width: 768px) {
    padding: 20px 50px;
  }
  /* padding: 10px 16px 2px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
`;

export const Title = styled.h3`
  font-size: 18px;
  color: #142c1f;
  margin-bottom: 25px;
`;

export const ComparisonTable = styled.div`
  width: 100%;
  margin: 0 0 20px 0;
  border-radius: 8px;
  overflow: hidden;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;

  .column-title {
    padding: 16px;
    font-weight: 600;
    text-align: center;
    color: #44554c;
    padding-bottom: 0px;
  }
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  border-radius: 8px;

  &:nth-child(even) {
    background-color: white;
  }
  &:nth-child(odd) {
    background-color: #f5faf9;
  }
`;

export const FeatureCell = styled.div`
  padding: 14px 16px;
  display: flex;
  align-items: center;
  color: #44554c;
`;

export const StatusCell = styled.div`
  padding: 14px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const ColumnTitle = styled.h3`
  color: #142c1f;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
`;
export const Divider = styled.div`
  display: block;
  @media screen and (max-width: 768px) {
    width: 90vw;
  }
  height: 1px;
  background-color: #e2e4e9;
  margin: 10px 0px;
  @media screen and (min-width: 768px) {
    display: none;
  }
`;

export const TestimonialGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const TestimonialCard = styled.div`
  border-radius: 8px;
  padding: 20 0px;
  display: flex;
  flex-direction: column;
`;

export const TestimonialHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

export const ProfileImageWrapper = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #8dcec3;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-right: 15px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const TestimonialUser = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Stars = styled.div`
  color: #ffc107;
  font-size: 18px;
  margin-bottom: 5px;
`;

export const UserName = styled.h3`
  font-size: 16px;
  margin: 0;
  color: #142c1f;
`;

export const UserAge = styled.p`
  font-size: 14px;
  color: #a5b5af;
  margin: 5px 0 0;
`;

export const TestimonialText = styled.p`
  font-size: 14px;
  line-height: 1.5;
  color: #44554c;
  margin: 0;
`;

export const MobileSliderView = styled.div`
  padding: 0px 16px;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const DesktopGridView = styled.div`
  padding: 20px 50px;

  max-width: 120rem;

  @media (max-width: 768px) {
    display: none;
  }
`;
